import React from "react";
import { SignUp } from "@clerk/clerk-react";
import { Avatar, Box, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SignUpPage = () => {
  const navigate = useNavigate();
  const navigateHome = () => {
    navigate("/");
  };
  return (
    <>
      <Card
        sx={{
          display: "flex",
          p: 5,
          boxShadow: "rgba(0, 0, 0, 0.25) 0px 25px 50px -12px",
          background: "#F9FAFB",
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <Box onClick={navigateHome} sx={{ display: "flex" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              pb: 3,
              mr: 1,
              cursor: "pointer",
            }}
          >
            <Avatar
              src="./assets/logo.png"
              sx={{
                backgroundColor: "success.main",
                height: 56,
                width: 56,
              }}
            />
          </Box>
          <Typography sx={{ cursor: "pointer" }} variant="h1">
            Fika
          </Typography>
        </Box>
        <div style={{ margin: "auto" }} className="signin-container">
          <SignUp
            appearance={{
              elements: {
                formButtonPrimary: "signin-button",
                card: "signin-card",
                formFieldInput: "signin-input",
                formHeaderTitle: "signin-header",
                footerActionLink: "signin-footer-link",
              },
            }}
            signInUrl="/signIn"
          />
        </div>
      </Card>
    </>
  );
};

export default SignUpPage;
